import { render, staticRenderFns } from "./RechargeRecordsDialog.vue?vue&type=template&id=2b30ffa6&scoped=true"
import script from "./RechargeRecordsDialog.vue?vue&type=script&lang=js"
export * from "./RechargeRecordsDialog.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecordsDialog.vue?vue&type=style&index=0&id=2b30ffa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30ffa6",
  null
  
)

export default component.exports